import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    selector: "app-note",
    templateUrl: "./note.component.html",
    styleUrls: ["./note.component.css"],
})
export class FormlyNoteComponent extends FieldType<FieldTypeConfig> {
    ngOnInit() {}
}
